import { ReminderBranchDetailsOutput } from './reminder-branch-details-output.model';
import { ReminderVehicleDetailsOutput } from './reminder-vehicle-details-output.model';
import { ReminderUserGroupOutput } from './reminder-user-group-output.model';
import { ReminderSmsOutput } from './reminder-sms-output.model';
import { ReminderEmailOutput } from './reminder-email-output.model';


export class ReminderWithStatusOutputData implements IReminderWithStatusOutputData {
    /** The auto-generated id of the reminder master */
    reminder_id!: number;
    /** The company name with 255 character */
    company_name!: string;
    /** The maintenance type with 255 character */
    maintenance_type_name!: string;
    /** The every month */
    every_month!: number;
    /** The every distance */
    every_distance!: number;
    /** The notify before days */
    notify_before_days!: number;
    /** The notify before distance */
    notify_before_distance!: number;
    /** The branch detailId */
    branch_detail_Id!: string;
    reminder_branch_data!: ReminderBranchDetailsOutput[];
    reminder_vehicle_details!: ReminderVehicleDetailsOutput[];
    reminder_user_id!: ReminderUserGroupOutput[];
    reminder_sms!: ReminderSmsOutput[];
    reminder_email!: ReminderEmailOutput[];
    /** The updated status */
    status!: number;

    constructor(data?: IReminderWithStatusOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminder_id = _data["reminder_id"];
            this.company_name = _data["company_name"];
            this.maintenance_type_name = _data["maintenance_type_name"];
            this.every_month = _data["every_month"];
            this.every_distance = _data["every_distance"];
            this.notify_before_days = _data["notify_before_days"];
            this.notify_before_distance = _data["notify_before_distance"];
            this.branch_detail_Id = _data["branch_detail_Id"];
            if (Array.isArray(_data["reminder_branch_data"])) {
                this.reminder_branch_data = [] as any;
                for (let item of _data["reminder_branch_data"])
                    this.reminder_branch_data!.push(ReminderBranchDetailsOutput.fromJS(item));
            }
            if (Array.isArray(_data["reminder_vehicle_details"])) {
                this.reminder_vehicle_details = [] as any;
                for (let item of _data["reminder_vehicle_details"])
                    this.reminder_vehicle_details!.push(ReminderVehicleDetailsOutput.fromJS(item));
            }
            if (Array.isArray(_data["reminder_user_id"])) {
                this.reminder_user_id = [] as any;
                for (let item of _data["reminder_user_id"])
                    this.reminder_user_id!.push(ReminderUserGroupOutput.fromJS(item));
            }
            if (Array.isArray(_data["reminder_sms"])) {
                this.reminder_sms = [] as any;
                for (let item of _data["reminder_sms"])
                    this.reminder_sms!.push(ReminderSmsOutput.fromJS(item));
            }
            if (Array.isArray(_data["reminder_email"])) {
                this.reminder_email = [] as any;
                for (let item of _data["reminder_email"])
                    this.reminder_email!.push(ReminderEmailOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ReminderWithStatusOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderWithStatusOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminder_id"] = this.reminder_id;
        data["company_name"] = this.company_name;
        data["maintenance_type_name"] = this.maintenance_type_name;
        data["every_month"] = this.every_month;
        data["every_distance"] = this.every_distance;
        data["notify_before_days"] = this.notify_before_days;
        data["notify_before_distance"] = this.notify_before_distance;
        data["branch_detail_Id"] = this.branch_detail_Id;
        if (Array.isArray(this.reminder_branch_data)) {
            data["reminder_branch_data"] = [];
            for (let item of this.reminder_branch_data)
                data["reminder_branch_data"].push(item.toJSON());
        }
        if (Array.isArray(this.reminder_vehicle_details)) {
            data["reminder_vehicle_details"] = [];
            for (let item of this.reminder_vehicle_details)
                data["reminder_vehicle_details"].push(item.toJSON());
        }
        if (Array.isArray(this.reminder_user_id)) {
            data["reminder_user_id"] = [];
            for (let item of this.reminder_user_id)
                data["reminder_user_id"].push(item.toJSON());
        }
        if (Array.isArray(this.reminder_sms)) {
            data["reminder_sms"] = [];
            for (let item of this.reminder_sms)
                data["reminder_sms"].push(item.toJSON());
        }
        if (Array.isArray(this.reminder_email)) {
            data["reminder_email"] = [];
            for (let item of this.reminder_email)
                data["reminder_email"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IReminderWithStatusOutputData {
    /** The auto-generated id of the reminder master */
    reminder_id: number;
    /** The company name with 255 character */
    company_name: string;
    /** The maintenance type with 255 character */
    maintenance_type_name: string;
    /** The every month */
    every_month: number;
    /** The every distance */
    every_distance: number;
    /** The notify before days */
    notify_before_days: number;
    /** The notify before distance */
    notify_before_distance: number;
    /** The branch detailId */
    branch_detail_Id: string;
    reminder_branch_data: ReminderBranchDetailsOutput[];
    reminder_vehicle_details: ReminderVehicleDetailsOutput[];
    reminder_user_id: ReminderUserGroupOutput[];
    reminder_sms: ReminderSmsOutput[];
    reminder_email: ReminderEmailOutput[];
    /** The updated status */
    status: number;
}

